import React, { useState, useEffect } from 'react';
import { ButtonGroup, Button, Tabs, Tab, Snackbar, Alert } from '@mui/material';
import Home from '../../../components/Home/HomeBox'
import ShiftReport from '../../../components/HomeHealthcare/ShiftReport'
import TimesheetsReport from '../../../components/Reports_V2/TimesheetsReport'
import IRecordSync from '../../../components/forms/BulkUploadForm/IRecordSync'
import WorkflowFormDialog from 'src/components/forms/WorkflowForm/WorkflowFormDialog';
import GridLayoutComponent from 'src/components/GridLayoutComponent/GridLayoutComponent';
import ScheduleShiftModal from 'src/container/Scheduler/Modals/ScheduleShiftModal';
import moment from 'moment';
import axios from 'axios'
import { APIURL } from '../../../config'

const HomeHealthcareEmployeeHome = (props) => {
    const [value, setValue] = useState('1');
    const [showWorkflow, setShowWorkflow] = useState(false);
    const [showShiftModal, setShowShiftModal] = useState(false);
    const [shiftModalData, setShiftModalData] = useState({
        resources: [],
        employees: [],
        customers: [],
        taskTypes: [],
        locations: [],
        contacts: [],
    });
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [refreshKey, setRefreshKey] = useState(0);

    const isAdmin = props.user.type === 'Admin';
    const isSubscibedToTimeManagement = props.user.subs.find((setting) => setting.feature_id === 12) ? true : false;
    const isSubscibedToBIandReporting = props.user.subs.find((setting) => setting.feature_id === 16) ? true : false;
    const isNJ = props.user.comp_settings.find(setting => setting.feature_id === 99 && setting.state_id === 'NJ');
    const isSupport = props.user.comp_settings.find(setting => setting.feature_id === 101 && setting.feature_value === 'primaryBusinessType') && isNJ;

    useEffect(() => {
        const checkTokenExpiry = () => {
            props.checkTokenExpiry();
        };
        checkTokenExpiry();
    }, [props])

    // Fetch shift modal data one at a time when modal opens, in field order
    useEffect(() => {
        if (!showShiftModal) return;
        let cancelled = false;
        const fetchProgressively = async () => {
            try {
                // 1. Customers
                const customersRes = await axios.get(`${APIURL}/customers`, { params: { com_id: props.comp_id } });
                if (cancelled) return;
                setShiftModalData(prev => ({ ...prev, customers: (customersRes.data || []).filter(c => c.cus_status === 'Active') }));

                // 2. Task Types
                const taskTypesRes = await axios.get(`${APIURL}/dropdowns/dropdownType/fullTaskType`, { params: { comp_id: props.comp_id } });
                if (cancelled) return;
                setShiftModalData(prev => ({ ...prev, taskTypes: (taskTypesRes.data || []).map(t => t.EntityValue) }));

                // 3. Resources
                const resourcesRes = await axios.get(`${APIURL}/resources/company/${props.comp_id}`);
                if (cancelled) return;
                setShiftModalData(prev => ({ ...prev, resources: (resourcesRes.data || []).filter(r => r.resource_is_active) }));

                // 4. Locations
                const locationsRes = await axios.get(`${APIURL}/location`, { params: { comp_id: props.comp_id } });
                if (cancelled) return;
                setShiftModalData(prev => ({ ...prev, locations: locationsRes.data || [] }));

                // 5. Contacts
                const contactsRes = await axios.get(`${APIURL}/contacts`, { params: { com_id: props.comp_id } });
                if (cancelled) return;
                setShiftModalData(prev => ({ ...prev, contacts: contactsRes.data || [] }));

                // 6. Employees
                const employeesRes = await axios.get(`${APIURL}/employees`, { params: { comp_id: props.comp_id } });
                if (cancelled) return;
                setShiftModalData(prev => ({ ...prev, employees: employeesRes.data || [] }));
            } catch (error) {
                console.error('Error loading shift modal data:', error);
                if (!cancelled) {
                    setSnackbar({ open: true, message: 'Failed to load some data for new shift', severity: 'error' });
                }
            }
        };
        fetchProgressively();
        return () => { cancelled = true; };
    }, [showShiftModal]);

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    value={value}
                >
                    <Tab onClick={() => setValue('1')} label="Home" value="1" />
                    {isAdmin && <Tab onClick={() => setValue('2')} label="Shift Report" value="2" />}
                    {isSubscibedToTimeManagement && <Tab onClick={() => setValue('3')} label="Timesheets Report" value="3" />}
                    {isAdmin && isSubscibedToBIandReporting && <Tab onClick={() => setValue('4')} label="Dashboard" value="4" />}
                    {props.user.type !== 'Fieldworker' && isSupport && <Tab onClick={() => setValue('5')} label="DDD Sync" value="5" />}
                </Tabs>
                <ButtonGroup size="small" sx={{ height: "40px", whiteSpace: "nowrap" }}>
                    {props.user.permissions.CreateNewWorkflow && <Button size="small" variant="contained" onClick={() => setShowWorkflow(true)}>NEW WORKFLOW</Button>}
                    <Button size="small" variant="contained" onClick={() => setShowShiftModal(true)}>NEW SHIFT</Button>
                </ButtonGroup>
            </div>
            {value === '1' &&
                <GridLayoutComponent
                    key={refreshKey}
                    {...props}
                    checkTokenExpiry={props.checkTokenExpiry}
                    user={props.user}
                    comp_id={props.comp_id}
                />
            }
            {value === '2' &&
                <div style={{ width: '98%' }}>
                    <ShiftReport key={refreshKey} user={props.user} comp_id={props.comp_id} />
                </div>
            }
            {value === '3' &&
                <div style={{ width: '98%' }}>
                    <TimesheetsReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                </div>
            }
            {value === '4' &&
                <div>
                    <Home {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                </div>
            }
            {value === '5' && isSupport &&
                <div>
                    <IRecordSync comp_id={props.comp_id} {...props}></IRecordSync>
                </div>
            }
            <div>
                <WorkflowFormDialog {...props} open={showWorkflow} handleClose={() => setShowWorkflow(false)} />
            </div>
            {showShiftModal && <ScheduleShiftModal
                open={showShiftModal}
                onClose={() => { setShowShiftModal(false); setShiftModalData({ resources: [], employees: [], customers: [], taskTypes: [], locations: [], contacts: [] }); }}
                user={props.user}
                comp_id={props.comp_id}
                resources={shiftModalData.resources}
                employees={shiftModalData.employees}
                customers={shiftModalData.customers}
                taskTypes={shiftModalData.taskTypes}
                locations={shiftModalData.locations}
                contacts={shiftModalData.contacts}
                isDayCare={false}
                reloadScheduleData={() => { setRefreshKey(k => k + 1); }}
                onSuccess={(msg) => setSnackbar({ open: true, message: msg, severity: 'success' })}
                onError={(msg) => setSnackbar({ open: true, message: msg, severity: 'error' })}
            />}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default HomeHealthcareEmployeeHome;